import { create } from "zustand";

export const ItemType = {
  MARKER: "Marker",
  EVIDENCE_REQUEST: "EvidenceRequest"
} as const;

export type HighlightItem = {
  id: string;
  type: (typeof ItemType)[keyof typeof ItemType];
}

type HighlightStore = {
  items: Map<string, HighlightItem>;
  addItem: (item: HighlightItem) => void;
  batchAddItem: (items: HighlightItem[]) => void;
  removeItem: (item: HighlightItem) => void;
  clear: () => void;
}

const useHighlightStore = create<HighlightStore>((set) => ({
  items: new Map(),
  // actions
  addItem: (item) => {
    set((pre) => {
      const newMap = new Map(pre.items);
      newMap.set(getItemKey(item), item);
      return { items: newMap };
    });
  },
  batchAddItem: (items) => {
    set((pre) => {
      const newMap = new Map(pre.items);
      items.forEach((item) => {
        newMap.set(getItemKey(item), item);
      });
      return { items: newMap };
    });
  },
  removeItem: (item) => {
    set((pre) => {
      const newMap = new Map(pre.items);
      newMap.delete(getItemKey(item));
      return { items: newMap };
    });
  },
  clear: () => {
    set({ items: new Map() });
  }
}));

export default useHighlightStore;

export function getItemKey(item: HighlightItem): string {
  return `${item.type}:${item.id}`;
}
